import { getPageContent } from './getPageContent';
export const useScrapePageTool = () => {
  return {
    getUrlContents: {
      async execute(params) {
        return {
          success: true,
          content: null,
          widgetResponse: JSON.stringify({
            ...params,
            pageContent: getPageContent()
          })
        };
      },
      // @ts-expect-error
      beforeExecute(params, request) {
        if (!request) {
          return;
        }
      }
    }
  };
};
//# sourceMappingURL=useScrapePageTool.js.map